import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function WhyOthersFail() {
  const reasons = [{
    title: 'Terapia tradicional',
    description: 'Costosa. Intimidante. Él no quiere ir. Y tú no quieres que otros sepan lo que pasa. La terapeuta Sara Vargas confirma que en la cultura latina, pedir ayuda externa todavía es un tabú.'
  }, {
    title: 'Consejos genéricos de internet',
    description: 'No están escritos pensando en nosotras. No consideran nuestras emociones, fe, responsabilidades ni nuestra cultura.'
  }, {
    title: 'Familiares y amigos',
    description: 'Solo saben decir: "Aguanta." "Sigue intentando." "Los hijos necesitan estabilidad." Pero ¿quién piensa en tu estabilidad?'
  }, {
    title: 'Rezar sin actuar',
    description: 'La fe reconforta, pero sin pasos concretos… nada cambia.'
  }];
  return <section className="py-8 md:py-12 bg-white" data-id="element-217">
      <div className="max-w-6xl mx-auto px-6" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-219">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2d2d2d] mb-6" data-id="element-220">
            POR QUÉ LAS OTRAS SOLUCIONES NO FUNCIONAN
          </h2>
          <div className="w-20 h-1 bg-[#9d4b6b] mx-auto rounded-full" data-id="element-221"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-222">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#faf8f6] p-6 rounded-xl border border-gray-100" data-id="element-223">
              <div className="flex items-start gap-3" data-id="element-224">
                <XCircle className="w-5 h-5 text-[#d4a5a5] flex-shrink-0 mt-1" data-id="element-225" />
                <div data-id="element-226">
                  <h3 className="text-lg font-serif font-bold text-[#2d2d2d] mb-2" data-id="element-227">
                    {reason.title}
                  </h3>
                  <p className="text-[#5a5a5a] leading-relaxed text-sm" data-id="element-228">
                    {reason.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}